import { CommonModule } from '@angular/common';
import { NgModule, Type } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { IonicModule } from '@ionic/angular';
import { IdlPipeModule } from '../../pipes/idlPipes.module';
import { ActesModule } from '../actes/actes.module';
import { FacturationService } from '../facturation/facturation.service';
import { OrdonnancesModule } from '../ordonnances/ordonnances.module';
import { PatientsModule } from '../patients/patients.module';
import { SeancesModule } from '../seances/seances.module';
import { ValidateActesModule } from '../traitement/validateActes/validate-actes.module';
import { TourneesService } from './services/tournees.service';
import { PipeModule } from '../../pipes';

const components: Type<any>[] = [
];

@NgModule({
	declarations: [
		...components
	],
	imports: [
		CommonModule,
		FormsModule,
		RouterModule,
		IonicModule,
		PipeModule,
		IdlPipeModule,
		MatExpansionModule,
		MatTooltipModule,
		ValidateActesModule,
		PatientsModule,
		SeancesModule,
		ActesModule,
		MatSnackBarModule,
		OrdonnancesModule,
	],
	providers: [TourneesService, FileOpener, FacturationService]
})
export class TourneesModule { }